module.exports = __webpack_public_path__ + "img/logo.b47be3e8.svg";